export default {
  categories: {
    shoes: 'Chaussures',
    hoodies: 'Hoodies / Sweats',
    tshirts: 'T-Shirts',
    jackets: 'Vestes',
    pants: 'Pantalons / Shorts',
    headwear: 'Couvre-chefs',
    sets: 'Ensembles',
    underwear: 'Sous-vêtements',
    jersey: 'Maillots',
    accessories: 'Accessoires',
    bags: 'Sacs',
    belts: 'Ceintures',
    perfumes: 'Parfums',
    other: 'Autres articles',
  },
  home: {
  hero: {
    badge: 'Ressource indépendante du spreadsheet USFans',
    h1: 'Spreadsheet USFans — liens produits, QC et guides d\'achat',
    subtitle: 'Explorez le spreadsheet USFans : ressources produits, liens utiles, infos QC, guides de livraison, détails d\'entrepôt, avis, coupons et conseils pratiques, le tout organisé au même endroit.',
    searchPlaceholder: 'Recherchez des produits USFans, des liens, du QC, la livraison ou des guides...',
    ctaPrimary: 'Spreadsheet USFans',
    ctaSecondary: 'Acheter maintenant',
    dropdownLabel: 'Choisissez une catégorie',
    dropdownHint: 'Accédez à une catégorie du site principal',
    trustLine: 'Ressource gratuite · Sans compte · Mise à jour régulièrement',
  },
  intro: {
    title: 'Qu\'est-ce que le spreadsheet USFans ?',
    p1: 'Le spreadsheet USFans est une ressource centralisée et organisée qui rassemble des liens produits, des détails de contrôle qualité (QC), des notes de livraison et des conseils d\'achat pour les amateurs de streetwear et de mode. Au lieu de fouiller des pages interminables, les acheteurs utilisent un document clair pour comparer les produits et trouver exactement ce qu\'il leur faut.',
    p2: 'Il sert de point de départ pratique : choisissez une catégorie, parcourez les articles, consultez les notes QC et de tailles, puis ouvrez le lien souhaité sur le site principal. Tout ce qu\'il faut pour acheter en toute confiance se trouve au même endroit.',
    point1: 'Liens produits regroupés par catégorie',
    point2: 'Références QC et de tailles',
    point3: 'Conseils de livraison et d\'entrepôt',
    point4: 'Indications de coupons et réductions',
  },
  categoriesSection: {
    title: 'Catégories populaires',
    subtitle: 'Ouvrez une catégorie ci-dessous pour parcourir les produits correspondants sur le site principal.',
  },
  qc: {
    title: 'QC et contrôles qualité',
    body: 'QC signifie contrôle qualité. Avant l\'envoi d\'un article, les acheteurs examinent souvent des photos pour confirmer la couleur, le logo, les coutures, la taille et l\'état général. Une bonne routine QC consiste à vérifier les mesures par rapport au guide des tailles et à demander des photos plus claires en cas de doute.',
    item1: 'Examinez les photos avant l\'envoi',
    item2: 'Vérifiez les mesures avec le guide des tailles',
    item3: 'Demandez de nouvelles photos si les détails sont flous',
    item4: 'Confirmez la couleur, le logo et les coutures',
  },
  review: {
    title: 'Avis USFans — est-ce légitime ?',
    body: 'USFansLink.site est une ressource d\'information indépendante, pas une page officielle de la marque. La sécurité d\'un achat dépend de la vérification du vendeur, de la lecture d\'avis de plusieurs sources et de l\'utilisation de moyens de paiement sécurisés.',
    legitTitle: 'Achat légitime et sûr',
    legit1: 'Vérifiez le vendeur avant de payer',
    legit2: 'Lisez des avis de plusieurs sources',
    legit3: 'Utilisez des paiements sécurisés et traçables',
    legit4: 'Méfiez-vous des liens suspects',
  },
  shipping: {
    title: 'Coût et délai de livraison',
    body: 'Le coût et le délai de livraison dépendent de votre destination, du mode d\'envoi et de la taille du colis. Certains acheteurs regroupent plusieurs articles via un entrepôt pour réduire le coût total.',
    item1: 'Confirmez le coût de livraison avant de commander',
    item2: 'Vérifiez le délai estimé pour votre pays',
    item3: 'Envisagez le regroupement d\'entrepôt pour plusieurs articles',
  },
  warehouse: {
    title: 'Entrepôt et stockage',
    body: 'Les commandes sont généralement emballées et inspectées dans un entrepôt avant l\'envoi. Les services d\'entrepôt peuvent stocker, inspecter et combiner des articles afin d\'expédier plusieurs produits ensemble et de payer moins cher.',
  },
  coupon: {
    title: 'Coupons et réductions',
    body: 'Les codes promo changent souvent, alors traitez chaque code comme temporaire. Testez-le au paiement et n\'utilisez que des codes provenant de sources fiables. Le spreadsheet peut vous indiquer les offres en cours ou expliquer où les réductions sont publiées.',
  },
  safety: {
    title: 'Centre de sécurité',
    body: 'Restez en sécurité pendant vos achats : évitez les faux sites, vérifiez les liens, protégez vos données de paiement et contrôlez toute offre qui semble trop belle pour être vraie.',
    item1: 'Méfiez-vous des sites faux ou copiés',
    item2: 'Ne partagez jamais négligemment mots de passe ou données de paiement',
    item3: 'Vérifiez les codes promo avant le paiement',
    item4: 'Contrôlez les liens suspects',
  },
  articles: {
    title: 'Derniers articles',
    subtitle: 'Des guides originaux pour utiliser le spreadsheet USFans en toute confiance.',
    cardTitle: 'Spreadsheet USFans : le guide complet',
    cardDesc: 'Un tour d\'horizon clair de ce que couvre le spreadsheet USFans, comment l\'utiliser et comment acheter en toute sécurité, des catégories au QC, en passant par la livraison et les coupons.',
    readMore: 'Lire le guide',
    tag: 'Guide',
  },
  faq: {
    title: 'Questions fréquentes',
    q1: 'Qu\'est-ce que le spreadsheet USFans ?',
    a1: 'C\'est une ressource centralisée qui rassemble des liens produits, des catégories, des infos QC, des notes de livraison et des conseils d\'achat au même endroit.',
    q2: 'USFansLink.site est-il une page officielle USFans ?',
    a2: 'Non. C\'est une ressource d\'information indépendante qui ne revendique aucune affiliation officielle.',
    q3: 'Comment utiliser les liens de catégorie ?',
    a3: 'Choisissez une catégorie dans le menu déroulant ou les boutons, puis ouvrez le lien correspondant pour parcourir les produits sur le site principal.',
    q4: 'Les prix et frais de livraison sont-ils toujours à jour ?',
    a4: 'Non. Les prix, la livraison et les promotions peuvent changer, alors vérifiez-les toujours sur la page produit avant de payer.',
    q5: 'Est-il sûr d\'acheter ?',
    a5: 'La sécurité dépend de la vérification du vendeur, de la lecture d\'avis et de moyens de paiement sécurisés. Méfiez-vous des liens inconnus et des offres trop belles pour être vraies.',
  },
  cta: {
    title: 'Prêt à parcourir le spreadsheet USFans complet ?',
    body: 'Ouvrez le site principal pour explorer les produits, vérifier le QC et comparer les options, le tout au même endroit.',
    button: 'Continuer vers le site principal',
  },
  disclaimer: 'USFansLink.site est une ressource d\'information indépendante. Les liens externes, produits, prix, informations de livraison et promotions peuvent changer. Vérifiez toujours les informations actuelles avant tout achat ou paiement.',
  },
};